import React, { createContext, useContext } from 'react';

import { FragmentHandler } from './FragmentHandler';

interface IFragmentContext {
  dataHandler: FragmentHandler | null | undefined;
  fragmentData: { [key: string]: any } | null;
}

const FragmentContext = createContext<IFragmentContext>({ dataHandler: null, fragmentData: {} });

interface IFragmentContextProviderProps {
  children: React.ReactNode;
  dataHandler?: FragmentHandler | null;
  data: { [key: string]: any } | null;
}

export const FragmentContextProvider: React.FC<IFragmentContextProviderProps> = ({ children, dataHandler, data }) => (
  <FragmentContext.Provider value={{ dataHandler, fragmentData: data }}>{children}</FragmentContext.Provider>
);

FragmentContextProvider.defaultProps = {
  dataHandler: null,
  data: null,
};

export const useFragmentContext = () => useContext(FragmentContext);
